<div class="header-container" [ngClass]="{'custom-keyboard-enabled': enableCustomKeyboard}">
    <mat-icon (click)="cancel()" svgIcon="close-line"></mat-icon>
</div>
<app-search-header header="Add Doctor" [showKeyboard]="true" [showClear]="true" [isReadonly]="true"
    placeholder="Search Doctor" [disableKeyPress]="disableKeyPress" (inputFocused)="onSearchHeaderInputFocused($event)"
    [setSearchInput]="searchValue">
</app-search-header>
<div class="app-container-list" [ngClass]="{'custom-keyboard-enabled': enableCustomKeyboard}">
    <cdk-virtual-scroll-viewport itemSize="10">
        <ng-container *cdkVirtualFor="let doctor of doctorList">
            <app-doctor-card class="doctor-card" [doctor]="doctor" (doctorSelected)="selectDoctor(doctor)">
            </app-doctor-card>
        </ng-container>
    </cdk-virtual-scroll-viewport>
    <div *ngIf="isCustomKeyboardVisible()" class="keyboard-container">
        <app-custom-keyboard #customKeyboard [template]="standardTemplate" [setValue]="searchValue"
            (typedValue)="customKeyboardInput($event)"></app-custom-keyboard>
    </div>
</div>